import type React from "react";
import {useOutletContext} from "react-router";
import type {SupplierDetailOutletContext} from "~/pages/supplier-360/types/Supplier360Types";
import {SemanticHealthBlock} from "./components/SemanticHealthBlock";
import {SignalFeedSection} from "./components/SignalFeedSection";
import {WorkforceBlock} from "./components/WorkforceBlock";

export const SupplierInsightsTab: React.FC = () => {
    const {entity} = useOutletContext<SupplierDetailOutletContext>();

    return (
        <>
            <SemanticHealthBlock entityId={entity.id}/>
            <WorkforceBlock entityId={entity.id}/>
            <SignalFeedSection entityId={entity.id}/>
        </>
    );
};
